module.exports = __webpack_public_path__ + "img/sysSetting.e3801516.svg";